/**
 * Safely retrieves SSR data from the window object.
 * Returns null if the property doesn't exist.
 * During SSR, window is polyfilled via JSDOM, so it's safe to access.
 *
 * @param propertyName - The property name on window to access (e.g., '__SSR_SITE_TRAITS__')
 * @returns The SSR data if available, null otherwise
 */
export function getSSRData<T>(propertyName: string): T | null {
	const windowWithSSR = window as typeof window & { [key: string]: T | undefined };
	return windowWithSSR[propertyName] ?? null;
}
